import { makeStyles } from "@material-ui/core/styles";
const useSlidesMenuStyles = makeStyles({
  container: {
    minWidth: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  toolbar: {
    minHeight: "50px",
    borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  list: {
    width: "100%",
    flexGrow: 1,
    paddingTop: "10px",
    overflowY: "auto",
  },
  slide: {
    display: "flex",
    gap: "5px",
    cursor: "pointer",
    "& .number": {
      fontSize: "10px",
      userSelect: "none",
    },
    "& .slidePrev": {
      "& > div": {
        borderRadius: "20px",
      },
    },
    "& .activeSlide": {
      "& > div": {
        // border: '5px solid #00A9A3',
        boxShadow: "0px 2px 8px 5px rgb(0,100,216)",
      },
    },
  },
});

export default useSlidesMenuStyles;
